var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllVideoOff = function SvgAllVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "all_video_off_svg__st0",
    d: "M18.9 15.2V8.1c0-.2-.2-.3-.4-.3l-3.2 1.9v-1c0-.3-.2-.6-.5-.6H12l6.9 7.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "all_video_off_svg__st0",
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm10.5 12c0 2.5-.9 4.8-2.4 6.6L5.4 3.9C7.2 2.4 9.5 1.5 12 1.5c5.8 0 10.5 4.7 10.5 10.5zm-21 0c0-2.7 1.1-5.2 2.8-7.1l3.3 3.3h-2c-.4 0-.6.2-.6.6v6.8c0 .3.2.6.5.6h9c.3 0 .5-.2.5-.4l4 4c-1.9 1.7-4.4 2.8-7.1 2.8C6.2 22.5 1.5 17.8 1.5 12z"
  })));
};
export default SvgAllVideoOff;